import { Translate } from "../services/translation.service";

export default function (value, namespace) {
    return Translate(value, namespace)
};